(function () {
  'use strict';

  function init() {
    var modal = document.getElementById('imageModal');
    if (!modal) return;

    var modalImage = document.getElementById('modalImage');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbnails .thumbnail'));
    if (!modalImage || thumbs.length === 0) return;

    function urlOf(t) { return t.getAttribute('data-full-url') || t.src; }
    var urls = thumbs.map(urlOf);
    var current = 0;

    var stage = document.createElement('div');
    stage.className = 'gf-modal-stage';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gf-modal-nav gf-modal-nav--prev';
    prev.setAttribute('aria-label', 'Vorheriges Bild');
    prev.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gf-modal-nav gf-modal-nav--next';
    next.setAttribute('aria-label', 'Nächstes Bild');
    next.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    var counter = document.createElement('div');
    counter.className = 'gf-modal-counter';

    var dots = document.createElement('div');
    dots.className = 'gf-modal-dots';
    urls.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'gf-modal-dot';
      d.setAttribute('aria-label', 'Bild ' + (i + 1));
      d.addEventListener('click', function (e) {
        e.stopPropagation();
        show(i);
      });
      dots.appendChild(d);
    });

    var origClose = modal.querySelector('.close-modal');
    if (origClose) origClose.classList.add('gf-modal-close');

    var imgWrap = document.createElement('div');
    imgWrap.className = 'gf-modal-img-wrap';
    if (modalImage.parentNode === modal) {
      modal.removeChild(modalImage);
    }
    imgWrap.appendChild(modalImage);

    stage.appendChild(prev);
    stage.appendChild(imgWrap);
    stage.appendChild(next);
    modal.appendChild(stage);
    modal.appendChild(counter);
    modal.appendChild(dots);

    modal.classList.add('gf-modal-enhanced');
    modal.setAttribute('onclick', '');
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === stage || e.target === imgWrap) closeModal();
    });
    [prev, next, counter, dots].forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    modalImage.addEventListener('click', function (e) { e.stopPropagation(); });

    function show(i) {
      if (i < 0) i = urls.length - 1;
      if (i >= urls.length) i = 0;
      current = i;
      modalImage.classList.add('gf-modal-img-fading');
      var img = new Image();
      img.onload = function () {
        modalImage.src = urls[current];
        requestAnimationFrame(function () {
          modalImage.classList.remove('gf-modal-img-fading');
        });
      };
      img.src = urls[current];
      counter.textContent = (current + 1) + ' / ' + urls.length;
      Array.prototype.forEach.call(dots.children, function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
      var thumb = thumbs[current];
      if (thumb && typeof window.changeImage === 'function') {
        window.changeImage(thumb);
      }
    }

    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
    window.closeModal = closeModal;

    var origOpen = window.openModal;
    window.openModal = function (src) {
      var idx = urls.indexOf(src);
      if (idx < 0) {
        for (var i = 0; i < urls.length; i++) {
          if (urls[i].split('?')[0] === (src || '').split('?')[0]) { idx = i; break; }
        }
      }
      if (idx < 0) idx = 0;
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      show(idx);
    };

    prev.addEventListener('click', function () { show(current - 1); });
    next.addEventListener('click', function () { show(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (modal.style.display !== 'flex') return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    var touchX = null;
    imgWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) touchX = e.touches[0].clientX;
    }, { passive: true });
    imgWrap.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = (e.changedTouches[0].clientX - touchX);
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      touchX = null;
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
